import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the API
 */
export class DataLockService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getDataLocks(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/data-locks' + params);		
		return data;
	}	
	
	async getDataLock(dataLockId) {
		var data = await this.makeGETRequest('/api/resource/data-locks/' + dataLockId);		
		return data;
	}	
	
	async getDataLockHistory(month, year) {
		var data = await this.makeGETRequest('/api/resource/data-locks/history/' + (month + '-' + year));		
		return data;
	}	
	
	async createLock(dataLock) {
		var saved = await this.makePOSTRequest('/api/resource/data-locks/lock', dataLock);
		return saved;
	}	
	
	async createUnlock(dataLock) {
		var saved = await this.makePOSTRequest('/api/resource/data-locks/unlock', dataLock);
		return saved;
	}	
	
}
